import { useEffect, useRef } from 'react';

export function useSyncHorizontalScroll(data: any, activeTab?: string) {
  const refs = useRef<Record<string, HTMLDivElement | null>>({});

  useEffect(() => {
    if (activeTab && data?.length > 0) {
      const elements = Object.values(refs.current).filter(Boolean);
      let isSyncing = false;

      const onScroll = (e: any) => {
        if (isSyncing) return;
        isSyncing = true;

        const scrollLeft = e.target.scrollLeft;
        elements.forEach(el => {
          if (el !== e.target) {
            el!.scrollLeft = scrollLeft;
          }
        });

        isSyncing = false;
      };

      elements.forEach(el => el!.addEventListener('scroll', onScroll));

      return () => {
        elements.forEach(el => el!.removeEventListener('scroll', onScroll));
      };
    }
  }, [data, activeTab]);

  return refs;
}
